import { Grid, Box, Typography, Table, TableBody, TableCell, TableRow } from "@mui/material";
import moment from "moment";

const ShippingInstructionsDownload = ({ formContent }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("Do MMMM, YYYY");
  };

  return (
    <>
      <div className="mx-4 premium-print-container" style={{ pageBreakInside: 'avoid' }}>
        {/* Header */}
        <Box sx={{ borderBottom: '2px solid var(--text-main)', mb: 3, pb: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: 'var(--text-main)', textTransform: 'uppercase', letterSpacing: '1px' }}>
            Shipping Instructions
          </Typography>
        </Box>

        {/* Top Details Section */}
        <Box sx={{ mb: 3, pb: 1, borderBottom: '2px solid #f1f5f9' }}>
          <Grid container justifyContent="space-between" alignItems="center">
            {/* Left Side: Mode */}
            <Grid item>
              {formContent?.airShipment?.trim()?.length > 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', fontSize: '10px' }}>
                    Mode of Shipment
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#0f172a', fontSize: '14px' }}>
                    {formContent.airShipment}
                  </Typography>
                </Box>
              )}
            </Grid>
            {/* Right Side: Date */}
            <Grid item>
              {formContent?.date?.trim()?.length > 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'right' }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748b', textTransform: 'uppercase', fontSize: '10px' }}>
                    Date
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#0f172a', fontSize: '14px' }}>
                    {formatDate(formContent.date)}
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>

        {/* Main Table */}
        <Box>
          <Table sx={{ border: '1px solid #e2e8f0' }}>
            <TableBody>
              {[
                { label: 'Shipper', key: 'shipper' },
                { label: 'Consignee', key: 'consignee' },
                { label: 'Notify', key: 'notify' },
                { label: 'Description', key: 'description' },
                { label: 'Volume/Gross Weight', key: 'grossWeight' },
                { label: 'Port of Discharge', key: 'portOfDischarge' },
                { label: 'Destination Country', key: 'destinationCountry' },
                { label: 'Remarks', key: 'remarks' }
              ].map((item) => {
                const value = formContent?.[item.key];
                if (value?.trim()?.length > 0) {
                  return (
                    <TableRow key={item.key}>
                      <TableCell
                        sx={{
                          width: '30%',
                          backgroundColor: '#f8fafc',
                          padding: '12px 16px',
                          borderBottom: '1px solid #e2e8f0',
                          borderRight: '1px solid #e2e8f0',
                          verticalAlign: 'top'
                        }}
                      >
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#475569', textTransform: 'uppercase', fontSize: '11px' }}>
                          {item.label}
                        </Typography>
                      </TableCell>
                      <TableCell
                        sx={{
                          width: '70%',
                          padding: '12px 16px',
                          borderBottom: '1px solid #e2e8f0',
                          verticalAlign: 'middle'
                        }}
                      >
                        <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 500, color: '#334155' }}>
                          {value}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                }
                return null;
              })}
            </TableBody>
          </Table>
        </Box>
      </div>
    </>
  );
};

export default ShippingInstructionsDownload;

